import React from "react";

export function Arrow({ direction = "diagonal" }) {
  const isUp = direction === "up";

  return (
    <span className={`arrow arrow--${direction}`} aria-hidden="true">
      <svg className="arrow__icon" viewBox="0 0 24 24" fill="none">
        <path
          className="arrow__frame"
          d={isUp ? "M5 9.5V19h14V9.5" : "M10 5H5v14h14v-5"}
        />
        <path
          className="arrow__mark"
          d={isUp ? "M12 16V5m-4 4 4-4 4 4" : "M10 14 19 5m-6 0h6v6"}
        />
      </svg>
    </span>
  );
}
